module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#premium",
      toString: function () {
        return this.url;
      }
    }